import dayjs from 'dayjs';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

import { isPastMealDay } from '@/helper/mealDateOrderable';
import { mealWeekIsos } from '@/helper/mealWeek';

function dayStatusLabel(iso, mark) {
	const base = dayjs(iso).format('dddd, D MMMM');
	const notes = [];
	if (isPastMealDay(iso)) notes.push('view orders only');
	if (mark?.paid) notes.push('paid orders');
	if (mark?.cart) notes.push('selections in cart');
	return notes.length ? `${base}, ${notes.join(', ')}` : base;
}

export default function WeekStrip({ dateIso, onSelect, dayMarks }) {
	const selected = dayjs(dateIso);
	const days = mealWeekIsos(dateIso);
	const selectedKey = selected.format('YYYY-MM-DD');
	const prevIso = selected.subtract(7, 'day').format('YYYY-MM-DD');
	const nextIso = selected.add(7, 'day').format('YYYY-MM-DD');

	return (
		<>
			<div className='weekstrip'>
				<button
					type='button'
					className='week-shift'
					aria-label='Previous week'
					onClick={() => onSelect?.(prevIso)}
				>
					<ChevronLeft fontSize='small' />
				</button>
				<div className='days' role='listbox' aria-label='Meal week'>
					{days.map((iso) => {
						const pressed = iso === selectedKey;
						const mark = dayMarks?.[iso];
						const past = isPastMealDay(iso);
						return (
							<button
								key={iso}
								type='button'
								role='option'
								aria-selected={pressed}
								aria-label={dayStatusLabel(iso, mark)}
								className={[pressed ? 'selected' : null, past ? 'past-view-only' : null]
									.filter(Boolean)
									.join(' ') || undefined}
								onClick={() => onSelect?.(iso)}
							>
								<span className='day-name' aria-hidden='true'>
									{dayjs(iso).format('ddd')}
								</span>
								<b aria-hidden='true'>{dayjs(iso).format('D')}</b>
								<span className='day-marks' aria-hidden='true'>
									{mark?.paid ? <span className='dot' /> : null}
									{mark?.cart ? <span className='dot dot-cart' /> : null}
								</span>
							</button>
						);
					})}
				</div>
				<button
					type='button'
					className='week-shift'
					aria-label='Next week'
					onClick={() => onSelect?.(nextIso)}
				>
					<ChevronRight fontSize='small' />
				</button>
			</div>
			<div className='week-meta'>
				<p className='muted'>{selected.format('dddd, D MMMM YYYY')}</p>
				<p className='week-legend'>
					<span className='week-legend-item'>
						<span className='dot' aria-hidden='true' /> Paid
					</span>
					<span className='week-legend-item'>
						<span className='dot dot-cart' aria-hidden='true' /> In cart
					</span>
				</p>
			</div>
		</>
	);
}
